import { Box } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { Description } from 'modules/marketplace/components/Description'
import { StepByStepDescription } from 'modules/marketplace/components/Description/StepByStepDescription'
import { TermsOfUse } from 'modules/marketplace/components/Item/TermsOfUse'
import { boxContainer } from 'modules/marketplace/components/Item/index.vanilla.css'

interface ContentProps {
  integration: ItemIntegrationFragment
}

export const IntegrationData = ({ integration }: ContentProps) => {
  const { description, datoId, stepByStepDescription } = integration

  return (
    <Box className={boxContainer} justifyContent="center">
      <Box paddingBottom="s48">
        {description && <Description description={description} id={datoId} />}
        {stepByStepDescription && (
          <StepByStepDescription stepByStepDescription={stepByStepDescription} id={datoId} />
        )}
        <Box paddingTop="s12">
          <TermsOfUse />
        </Box>
      </Box>
    </Box>
  )
}
